<template>
  <div class="mx-auto">
    <div
      class="flex flex-col sm:flex-row items-stretch justify-center space-y-1 sm:space-y-0 sm:space-x-4"
    >
      <OverviewCard
        :icon="{name: 'meter-icon', color: 'gray-500'}"
        :amount="{
          volume: new Intl.NumberFormat($i18n.locale).format(total.meters),
          increase: true,
          delta: 2,
        }"
        label="total_meters"
      />
      <OverviewCard
        :icon="{name: 'volume2', color: 'blue-light'}"
        :amount="{
          volume: new Intl.NumberFormat($i18n.locale).format(total.volume),
          increase: true,
          delta: 120,
        }"
        label="total_volume"
      />
      <OverviewCard
        :icon="{name: 'readout', color: 'green-light'}"
        :amount="{
          volume: new Intl.NumberFormat($i18n.locale).format(total.readouts),
          increase: false,
          delta: 122,
        }"
        label="total_readouts"
      />
      <OverviewCard
        :icon="{name: 'error', color: 'orange-light'}"
        :amount="{
          volume: new Intl.NumberFormat($i18n.locale).format(total.alerts),
          increase: false,
          delta: 12,
        }"
        label="total_alerts"
      />
    </div>
  </div>
</template>

<script>
import OverviewCard from '@/components/shared/OverviewCard.vue'

export default {
  props: {
    total: {
      type: Object,
      required: true,
    },
  },
  components: {
    OverviewCard,
  },
}
</script>
